import React from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import objectTypeService from '../../../services/cms/objectTypeServiceRequest';
import { safeParseColumns } from '../../../utils/utility';

const { Text } = Typography;

const QuanLyLoaiDoiTuong = () => {
  const formFields = [
    { name: 'name', label: 'Tên loại', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tên loại!' }], placeholder: 'Tên loại đối tượng' },
    { name: 'description', label: 'Mô tả', type: 'textarea', placeholder: 'Mô tả loại đối tượng' },
    { type: 'divider', label: 'Cột giá trị' },
    {
      name: 'columns_rows',
      type: 'group',
      isSort: true,
      titleButtonAdd: 'Thêm cột',
      filedsList: [
        { name: 'title', type: 'input', placeholder: 'Tên cột', rules: [{ required: true, message: 'Vui lòng nhập tên cột!' }] },
      ],
    },
    { name: 'alert_info', label: 'Thông báo', type: 'textarea', placeholder: 'Thông tin thông báo (JSON)', propsInput: { rows: 2 } },
  ];

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: 'TÊN LOẠI', dataIndex: 'name', key: 'name', render: (text) => <Text strong>{text}</Text> },
    { title: 'MÔ TẢ', dataIndex: 'description', key: 'description', width: 250, ellipsis: true },
    {
      title: 'CỘT',
      dataIndex: 'columns',
      key: 'columns',
      width: 200,
      render: (raw) => {
        const list = safeParseColumns(raw);
        return list.length ? (
          <div>
            {list.map((name, index) => (
              <div key={index}>{name}</div>
            ))}
          </div>
        ) : (
          '-'
        );
      },
    },
    { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (time) => (time ? dayjs(time).format('DD/MM/YYYY HH:mm') : '-') },
  ];

  // DB lưu columns là chuỗi JSON mảng tên cột — form dùng dạng dòng {title} để thêm/xóa/kéo thả
  const mapDataToForm = (record) => ({
    columns_rows: safeParseColumns(record.columns).map((title) => ({ title })),
  });

  const mapFormToData = (values) => ({
    columns: JSON.stringify((values.columns_rows || []).map((row) => row?.title?.trim()).filter(Boolean)),
    columns_rows: undefined, // key ảo, validator API không nhận — undefined sẽ bị loại khi serialize
  });

  return (
    <CrudPage
      title="QUẢN LÝ LOẠI ĐỐI TƯỢNG"
      subTitle="Quản lý các loại đối tượng trong hệ thống"
      itemsName="Loại đối tượng"
      queryKey="objectTypeList"
      service={objectTypeService}
      columns={columns}
      formFields={formFields}
      searchPlaceholder="Tìm kiếm theo tên loại..."
      addButtonLabel="Thêm loại"
      mapDataToForm={mapDataToForm}
      mapFormToData={mapFormToData}
    />
  );
};

export default QuanLyLoaiDoiTuong;
